// extracted by mini-css-extract-plugin
module.exports = {"root":"bg_bJ"};